import {appSessionStorage} from "../../../shared/services";

export function createTimeframesModule(storageKeyPrefix: string, apiScope: string|null = null) {
  const initialState = () => {
    return {
      hasError: false,
      timeframes: [],
      timeframesEnabled: false,
      selectedTimeframe: appSessionStorage.getItem(`selected-${storageKeyPrefix}-timeframe`, {}),
      loadingTimeframes: false,
    };
  }

  const getters = {
    hasError: (state) => state.hasError,
    timeframes: (state) => state.timeframes,
    timeframesEnabled: (state) => state.timeframesEnabled,
    selectedTimeframe: (state) => state.selectedTimeframe,
    loadingTimeframes: (state) => state.loadingTimeframes,
  };

  const mutations = {
    SET_TIMEFRAME(state, timeframe) {
      appSessionStorage.setItem(`selected-${storageKeyPrefix}-timeframe`, timeframe);
      state.selectedTimeframe = timeframe;
    },
    SET_TIMEFRAMES(state, data) {
      state.timeframes = data;
    },
    SET_NO_TIMEFRAMES(state, hasError) {
      state.hasError = hasError;
    },
    SET_LOADING_TIMEFRAMES(state, status) {
      state.loadingTimeframes = status;
    },
    SET_TIMEFRAMES_ENABLED(state, status) {
      state.timeframesEnabled = status;
    },
  };

  const actions = {
    async timeframesEnabled({rootState, state, commit}) {
      try {
        let enabledEndpoint = '/api/checkout/timeframes/enabled';
        if (apiScope) {
          enabledEndpoint += `?scope=${apiScope}`;
        }
        const {data} = await this.$solarClient.get(enabledEndpoint);

        await commit('SET_TIMEFRAMES_ENABLED', !!data);
      } catch (err) {
        await commit('SET_TIMEFRAMES_ENABLED', false);
      }
    },
    async collectTimeFrames({rootState, state, commit, dispatch}) {
      await dispatch('timeframesEnabled');
      commit('SET_LOADING_TIMEFRAMES', true);
      commit('SET_NO_TIMEFRAMES', false);

      try {
        let collectEndpoint = '/api/checkout/timeframes/collect';
        if (apiScope) {
          collectEndpoint += `?scope=${apiScope}`;
        }
        const {data} = await this.$solarClient.get(collectEndpoint);

        await commit('SET_TIMEFRAMES', data);

        if (data.hasOwnProperty('status') && data['status'] === 'error') {
          await commit('SET_NO_TIMEFRAMES', true);
        }
      } catch (err) {
        await commit('SET_NO_TIMEFRAMES', true);
        await commit('SET_TIMEFRAMES', []);
      } finally {
        commit('SET_LOADING_TIMEFRAMES', false);
      }
    },
    setTimeframe({state, commit, dispatch}, timeframe) {
      commit('SET_TIMEFRAME', timeframe);

      commit('CheckoutPayment/ADD_SHIPPING_OPTIONS', {
        timeframe: timeframe
      }, {root: true});
    },
    removeTimeframes({commit}) {
      commit('SET_TIMEFRAME', null);
      appSessionStorage.removeItem(`selected-${storageKeyPrefix}-timeframe`);

      commit('CheckoutPayment/CLEAR_SHIPPING_OPTIONS', undefined, {root: true});
    },
  }

  return {
    namespaced: true,
    state: initialState(),
    getters,
    actions,
    mutations
  };
}
